import { makeStyles } from '@material-ui/core'
import { spacing } from '../../style-guide'

export const useStyles = makeStyles({
  container: {
    ...spacing.margin.m
  }
})
